<template lang="pug">
v-card.custom-card(outlined)
  v-card-title.custom-card-title {{ titulo }}
  v-card-text.custom-card-body
    .d-flex.flex-wrap.gap-2
      v-chip.persona-filter-chip(
        v-for="persona in itens",
        :key="persona[itemKey]",
        :class="{ 'persona-selecionada': estaSelecionada(persona) }",
        outlined,
        small,
        @click="$emit('toggle', persona)"
      )
        v-icon(x-small, left) {{ estaSelecionada(persona) ? "mdi-check" : "" }}
        | {{ persona[itemText] }}
</template>

<script>
export default {
  name: "FiltroCaracterizacaoCard",

  props: {
    titulo: {
      type: String,
      default: "Filtrar por caracterização"
    },
    itens: {
      type: Array,
      default: () => []
    },
    selecionados: {
      type: Array,
      default: () => []
    },
    itemKey: {
      type: String,
      default: "tipoempresa"
    },
    itemText: {
      type: String,
      default: "tipo_empresa"
    }
  },

  methods: {
    estaSelecionada(persona) {
      return this.selecionados.includes(persona);
    }
  }
};
</script>

<style scoped>
.custom-card {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: #fff;
  border: 1px solid #d9e2ec !important;
  border-radius: 18px 6px 18px 6px !important;
  box-shadow: 0 2px 8px rgba(15, 42, 77, 0.08) !important;
}

.custom-card-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  scrollbar-width: thin;
}

.custom-card-title {
  flex: 0 0 auto;
  min-height: 56px;
  padding: 0 18px;
  display: flex;
  align-items: center;
  color: #0f2b57;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.3;
  background-color: #e3f2fd;
  border-radius: 18px 6px 0 0;
}

.custom-card-body {
  padding: 12px 18px 16px !important;
}

.gap-2 {
  gap: 8px;
}

.persona-filter-chip {
  border-color: #b0bec5;
  color: #546e7a;
  font-weight: 500;
  font-size: 12px;
  border-radius: 16px;
  transition: all 0.15s ease;
}

.persona-filter-chip:hover {
  background-color: #e3f2fd;
  border-color: #1976d2;
  color: #1976d2;
}

.persona-selecionada {
  background-color: #1976d2 !important;
  border-color: #1976d2 !important;
  color: #1976d2 !important;
}
</style>
